const GOOGLE_MAPS_API_KEY = "AIzaSyD3s00hGFu8g4rVv19_nnEaIx1Joj1EtI0";
export default GOOGLE_MAPS_API_KEY;
